module.exports = __webpack_public_path__ + "media/images/pages/secondary-senior-leaders/teaching-70d80aff0f22bb5c83d1934943c38efa.png";